<div class="container">
  <div class="formSection">
    <div class="head">
      <strong>Documents ({{doculemtList?.length > 0 ? doculemtList?.length : 0}})</strong>
    </div>
    <table>
      <th class="col-md-3">Document Type</th>
      <th class="col-md-3">Document Number</th>
      <th class="col-md-3">Document Date</th>
      <th class="col-md-3" *ngIf="showIsVerified">Verified</th>
      <!-- <th class="col-md-3">View</th> -->
      <th class="col-md-3">Download</th>
      <tr class="flex flex-col gap-2" *ngFor="let doc of doculemtList; ">
        <td>{{doc?.documentSubType}}</td>
        <td>{{doc?.documentNumber}}</td>
        <td>{{ doc?.documentDate | date:'yyyy-MM-dd' }}</td>
        <!-- <td>this is for view icon</td> -->
        <td *ngIf="showIsVerified">
          <img class="verification-Icon" src="{{verifiedIcon}}" *ngIf="doc?.isVerified" />
          <img class="verification-Icon" src="{{unVerifiedIcon}}" *ngIf="!doc?.isVerified" />
        </td>
        <td>
          <img src="{{ downloadIcon}}" (click)="downloadFile(doc)"
            style="filter: invert(1) grayscale(1) brightness(0); cursor: pointer;" />
        </td>
      </tr>
    </table>
  </div>
</div>